import { replaceAllOccurence } from "@swiggy-private/core-ui";
import {
    CONTAINER_MIN_HEIGHT,
    LOTTIE_CONTAINER_HEIGHT,
    LOTTIE_CONTAINER_HEIGHT_WITH_SECONDARY_CALLOUTS,
} from "./constants";

export const getContainerMinHeight = (secondaryCalloutsExist: boolean, primaryTextIsLong: boolean) => {
    if (primaryTextIsLong) {
        return secondaryCalloutsExist
            ? CONTAINER_MIN_HEIGHT.WITH_SECONDARY_CALLOUTS_AND_LONG_PRIMARY_SAVINGS_INFO
            : CONTAINER_MIN_HEIGHT.DEFAULT_AND_LONG_PRIMARY_SAVINGS_INFO;
    }
    return secondaryCalloutsExist ? CONTAINER_MIN_HEIGHT.WITH_SECONDARY_CALLOUTS : CONTAINER_MIN_HEIGHT.DEFAULT;
};

export const getLottieContainerHeight = (secondaryCalloutsExist: boolean) => {
    return secondaryCalloutsExist ? LOTTIE_CONTAINER_HEIGHT_WITH_SECONDARY_CALLOUTS : LOTTIE_CONTAINER_HEIGHT;
};

export const getAriaLabel = (
    primaryText?: string,
    primarySubtext?: string,
    secondaryText?: string,
    secondarySubtext?: string,
) => {
    return replaceAllOccurence(
        `${primaryText || ""}, ${primarySubtext || ""}, ${secondaryText || ""}, ${secondarySubtext || ""}`,
        "₹",
        "rupees",
    );
};
